// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

/**
 * Bold downward chevron used as the expand/collapse affordance on the
 * advisor wizard's saved-policy cards (rotated 180° by the caller when
 * expanded). Extracted verbatim from the previous inline SVG so the
 * visual is pixel-identical.
 */
const ExpandChevronDownIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || '#141414';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="expand chevron down"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M12 16.8006C11.3 16.8006 10.6 16.5306 10.07 16.0006L3.55002 9.48062C3.26002 9.19062 3.26002 8.71062 3.55002 8.42063C3.84002 8.13063 4.32002 8.13063 4.61002 8.42063L11.13 14.9406C11.61 15.4206 12.39 15.4206 12.87 14.9406L19.39 8.42063C19.68 8.13063 20.16 8.13063 20.45 8.42063C20.74 8.71062 20.74 9.19062 20.45 9.48062L13.93 16.0006C13.4 16.5306 12.7 16.8006 12 16.8006Z" fill={fill} />
    </svg>
  );
};

export { ExpandChevronDownIcon };
